module.exports = __webpack_public_path__ + "static/img/download_back6.7618f2e5.png";